export default [
  {
    value: -1,
    label: '封禁'
  },
  {
    value: 1,
    label: '激活'
  }
]
